import React, { useState, useEffect } from 'react'
import { Col, Panel, Row } from 'rsuite'
import { sessionSetItemStr } from '../../utils/sessionHelpers'
import moment from 'moment'
import { DATE_FORMAT } from '../../constants/date'

export default function MiniProjectInfo(props) {
  const [formSchema, setFormSchema] = useState(props.schema)

  useEffect(() => {
    const _projectEndDate = formSchema?.projectEndDate
      ? moment(formSchema?.projectEndDate).format(DATE_FORMAT)
      : ''
    const _projectStartDate = formSchema?.projectStartDate
      ? moment(formSchema?.projectStartDate).format(DATE_FORMAT)
      : ''
    sessionSetItemStr('projectEndDate', _projectEndDate || '')
    sessionSetItemStr('projectStartDate', _projectStartDate || '')
  }, [formSchema])

  return (
    <>
      <Panel
        bordered
        style={{
          backgroundColor: '#cccbca4d',
          border: '1px solid #4e4b488c',
        }}
      >
        <Row>
          <Col lg={12} md={12} sm={24} xs={24}>
            <b>{formSchema?.projectCodeLabel || 'รหัสโครงการ : '}</b>
            {formSchema?.projectCode || ''}
          </Col>
          <Col lg={12} md={12} sm={24} xs={24}>
            <b>{formSchema?.contractNoLabel || 'เลขที่ข้อตกลง : '}</b>
            {formSchema?.contractNo || ''}
          </Col>
        </Row>
        <Row>
          <Col lg={12} md={12} sm={24} xs={24}>
            <b>{formSchema?.projectNameLabel || 'ชื่อโครงการ : '}</b>
            {formSchema?.projectName || ''}
          </Col>
          <Col lg={12} md={12} sm={24} xs={24}>
            <b>{formSchema?.coordinatorLabel || 'ผู้ประสาน : '}</b> {formSchema?.coordinator || ''}
          </Col>
        </Row>
        <Row>
          <Col lg={12} md={12} sm={24} xs={24}>
            <b>{formSchema?.durationLabel || 'ระยะเวลาดำเนินงาน : '}</b>
            {formSchema?.duration ? `วันที่ ${formSchema?.duration}` : ''}
          </Col>
          <Col lg={12} md={12} sm={24} xs={24}>
            <b>{formSchema?.responsiblerLabel || 'ผู้รับผิดชอบโครงการ : '}</b>
            {formSchema?.responsibler || ''}
          </Col>
        </Row>
        <Row>
          <Col lg={12} md={12} sm={24} xs={24}>
            <b>{formSchema?.countOfSubProjectLabel || 'มีโครงการย่อย : '}</b>
            {formSchema?.countOfSubProject > 0
              ? `มี (${formSchema?.countOfSubProject} โครงการย่อย)`
              : '-'}
          </Col>
          <Col lg={12} md={12} sm={24} xs={24}>
            <b>{formSchema?.projectStatusLabel || 'สถานะโครงการ : '}</b>
            {formSchema?.projectStatus || ''}
          </Col>
        </Row>
        <Row>
          <Col lg={12} md={12} sm={24} xs={24}>
            <b>{formSchema?.isPurchaseOfDurableGoodsLabel || 'งบครุภัณฑ์ : '}</b>
            {formSchema?.isPurchaseOfDurableGoods || ''}
          </Col>
          <Col lg={12} md={12} sm={24} xs={24}></Col>
        </Row>
      </Panel>
    </>
  )
}
